import { FC } from 'react';

//components
import FooterService from './footer-service';

//styles
import styles from './footer-banner.module.scss';

//assets
import { servicesData } from 'Data/footer-assets';

const FooterBanner: FC = () => (
  <div className={styles.footerBannerContainer} data-testid="footer-banner">
    <div className={styles.footerWrapper}>
      {servicesData?.map((service) => (
        <FooterService key={service.title} service={service} />
      ))}
    </div>
  </div>
);

export default FooterBanner;
